import { RoleHost } from '../RoleHost';

export function RBWrapper() {
  return <RoleHost role="rb" />;
}
